import {SODeleteAppliedConstraint} from '../../core/applied-constraint/so-delete-applied-constraint';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteAppliedConstraint extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteAppliedConstraint;
}